import * as React from 'react';

import { head, last } from 'lodash';

import { Workflow } from '@portal/components/claims/workflow';
import { ClaimPropertySelectionAction, claimPropertySelectionURL } from '@portal/config/routes';

import { Declaration } from './declaration';
import { Name } from './name';
import { Owner } from './owner';
import { Photos } from './photos';
import { Quotes } from './quotes';

interface IStep {
  action: ClaimPropertySelectionAction;
  component(): JSX.Element;
}

const STEPS: IStep[] = [
  { action: 'name', component: Name },
  { action: 'owner', component: Owner },
  { action: 'photos', component: Photos },
  { action: 'quote', component: Quotes },
  { action: 'declaration', component: Declaration },
];

export const HEAD = head(STEPS)!.action;
export const TAIL = last(STEPS)!.action;

interface IWizardProps {
  onNext(): void;
  onPrev(): void;
}

export const Wizard = (props: IWizardProps) => (
  <Workflow
    {...props}
    steps={STEPS}
    url={({ uuid, action }) => claimPropertySelectionURL(uuid, action as ClaimPropertySelectionAction)}
  />
);
